export default __webpack_public_path__ + "7b7b053a8b8a9ea3fe2f404e9573b4b6.png";